/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    asyncDefaults,
    startReducerFn,
    failureReducerFn,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from 'ui-permit/shared-components/utils/async';
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';

const addReservation = makeAsyncReducer(ACTIONS.ADD_RESERVATION);
const fetchReservation = makeAsyncReducer(ACTIONS.FETCH_RESERVATION);
const updateReservation = makeAsyncReducer(ACTIONS.UPDATE_RESERVATION, {
    initialData: null,
    start: startReducerFn,
    success: (state, action) => ({
        loading: false,
        loaded: true,
        error: null,
        data: action?.payload?.issuance,
    }),
    failure: failureReducerFn,
});
const resetReservation = makeAsyncResetReducer(ACTIONS.RESET_RESERVATION, {});

const addLotteryApplication = makeAsyncReducer(ACTIONS.ADD_LOTTERY_APPLICATION, {
    initialData: null,
    start: startReducerFn,
    success: (state) => ({ loading: false, loaded: true, error: null, data: state.data }),
    failure: failureReducerFn,
});

const reservation = mergeReducers(
    asyncDefaults({}),
    PREFIX,
    addReservation,
    fetchReservation,
    updateReservation,
    resetReservation,
    addLotteryApplication
);

export default reservation;

export const selectors = {
    getReservation: (state) => state.huntingpermit.reservation.data,
    getReservationError: (state) => state.huntingpermit.reservation.error,
    getReservationLoading: (state) => state.huntingpermit.reservation.loading,
};
